// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox-1ar0t"};